import axios from 'axios'
import qs from 'qs'
import Vue from 'vue'
export default {
  // requestUrl, {
  //   Authorization: window.localStorage.getItem('Authorization'),
  //   responseType: 'arraybuffer'
  // }
  downLoadFileWithUrl: async function (that, requestUrl, fileName, formData) {
    Vue.$showLoading.show()
    axios({
      headers: {
        'Content-Type': 'application/json;charset=UTF-8;',
        Authorization: localStorage.getItem('Authorization')
      },
      method: 'GET',
      url: requestUrl,
      params: formData,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      }
    }).then((res) => {
      Vue.$showLoading.hide()
      console.log('res.data', res.data)
      if (res.data.code === 200) {
        if (res.data.data.noPromotedUrl) {
          var downloadUrl = [res.data.data.noPromotedUrl, res.data.data.promotedUrl]
          for (let index = 0; index < downloadUrl.length; index++) {
            const iframe = document.createElement('iframe')
            iframe.style.display = 'none' // 防止影响页面
            iframe.style.height = 0 // 防止影响页面
            iframe.src = downloadUrl[index]
            document.body.appendChild(iframe) // 这一行必须，iframe挂在到dom树上才会发请求
            // 之后删除
            setTimeout(() => {
              iframe.remove()
            }, 1000)
          }
        } else {
          window.location.href = res.data.data
        }
      } else {
        Vue.prototype.$message.error(res.data.msg)
      }
    }).catch((err) => {
      Vue.$showLoading.hide()
      console.log(err)
    })
  }
}
